<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Заказ завершен
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'

  export default {
    name: 'HistoryItemTypeComplete',
    components: { UserInfoLabel, Avatar },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
